import oracle from "../fixtures/oracle.json";
import { initial, documentGenerator, jsonGenerator, jsonForHTML } from "./demo";
import type { Input } from "./engine/types";
export function corpusInputs(): Input[] {
  return Array.from({ length: 200 }, (_, idx) => {
    const r = structuredClone(initial);
    r.id = `article-${String(idx + 1).padStart(3, "0")}`;
    r.url = `https://atelier.example/journal/${r.id}`;
    r.title = `Dossier ${idx + 1} — un support qui tient parole`;
    r.breadcrumb[2].name = r.title;
    const graph = jsonGenerator(r);
    const m = oracle.mutations.find((m) => m.id === r.id);
    const g: any[] = graph["@graph"];
    if (m) {
      if (m.category === "date") g[0].dateModified = m.value;
      if (m.category === "author") g[1].name = m.value;
      if (m.category === "faq")
        g[3].mainEntity[0].acceptedAnswer.text = m.value;
      if (m.category === "breadcrumb") g[2].itemListElement[1].name = m.value;
    }
    return {
      name: r.id + ".html",
      html: documentGenerator(r).replace(
        /<script type="application\/ld\+json">[\s\S]*?<\/script>/,
        `<script type="application/ld+json">${jsonForHTML(graph)}</script>`,
      ),
      mode: "html_source",
      provenance: "Corpus fictif déterministe, oracle indépendant 1.0.0",
    };
  });
}
